var render = function render(){var _vm=this,_c=_vm._self._c;return _c('master-default',[_c('h1',{on:{"click":function($event){return _vm.refresh()}}},[_vm._v(_vm._s(_vm.res.chave))]),_c('sub-demo'),_vm._v(" ok22 "+_vm._s(_vm.msg)+" "+_vm._s(_vm.reqinfo)+" "),_c('v-btn',{on:{"click":function($event){return _vm.acaoTeste()}}},[_vm._v("Chama Ação")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }